<template>
    <div class="main-content">
        <!-- Navbar -->
        
        <base-nav class="navbar-top navbar-horizontal navbar-dark" containerClasses="py-12 container" expand >
            <a slot="brand" class="navbar-brand" :href="urlAltResimple">
                <img src="/img/brand/white.png" style="height:70px;" class="img-resposive"/>
            </a>
        
          <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="/img/brand/logoh.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
            </template>
        </base-nav>
        
        <!-- Header -->
        <div class="header rsgradient py-6 py-lg-7">
            <div class="container">
                <div class="header-body text-center mb-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-6">
                            <h1 class="text-white welcome">Bienvenido</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                            &copy; {{year}} Resimple SA
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <li class="nav-item">
                                <a href="https://www.resimple.com.ar" class="nav-link" target="_blank">Resimple</a>
                            </li>
                            <li class="nav-item">
                                <a href="https://www.resimple.com.ar/legales" class="nav-link" target="_blank">Términos y Condiciones</a>
                            </li>
                            <li class="nav-item">
                                <a href="https://www.resimple.com.ar/#contacto" class="nav-link" target="_blank">Contacto</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    
</template>
<script>
  import axios from 'axios';
  import axiosHelpers from "@/helpers/axiosHelpers";
  import { SlideYUpTransition } from 'vue2-transitions';

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        urlAltResimple: ''
      }
    },
     methods: {
        GetUrlAltResimple(){
            let context = this;

            axiosHelpers.axiosGet("Account/GetUrlAltResimple", {}, context, function(data){
                context.urlAltResimple = data.ResponseVM.Url;
            });
            },
        },
         beforeMount: function() {
            this.GetUrlAltResimple();
        }
    }
</script>
<style scoped>
    .welcome
    {
        font-family: Open Sans, sans-serif !important;
        font-weight: 600!important;
    }
</style>
